import Vue from 'vue';
import App from './App';
import RouterConfig from './router';
import StoreConfig from './store';


import Fundation from 'fundation-app-vuejs';
import { Router, Store, I18n } from 'fundation-app-vuejs';
import metaDefinition from './store/meta';

import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/fr';

Vue.use(ElementUI, { locale });
import Tooltip from 'vue-directive-tooltip';
// import 'vue-directive-tooltip/css/index.css';

Vue.use(Fundation);
Vue.use(Tooltip);

StoreConfig.metaDefinition = metaDefinition;
StoreConfig.apiRootUrl = window.config.api_root_url;

Vue.config.productionTip = false;
let localesConfig = {
    messages: { fr: 'fr', en: 'en' },
    locale: 'fr' // ajouter "defaultLanguage"
};


/* eslint-disable no-new */
let app = new Vue({
    el: '#app',
    router: new Router(RouterConfig),
    store: new Store(StoreConfig),
    i18n: new I18n(localesConfig),
    components: { App },
    template: '<App/>',
});


function translation(key, context) { return app.$t(key, context); };
// we add i18n's $t() function to fundation's store so we can use it with a getter in fundation
app.$store.commit('fundation/SET_TRANSLATION_METHOD', translation);

/* 
  set i18n locale: 
    required if not using dashboardLayout or not using fundation's App.vue
    else if not set, fundation will use defaultLanguage getters as i18n default locale
*/
app.$store.dispatch('fundation/changeLang', { lang: 'fr', i18n: app.$i18n });

// pour supprimer le loader 1 une fois fundation chargé
let loading1 = document.querySelector('#loading1');
loading1.parentNode.removeChild(loading1);

window.app = app;




// WEBPACK FOOTER //
// ./src/main.js